import React from 'react';
import * as Switch from '@radix-ui/react-switch';
import Flex from '../Flex';
import styles from './ToggleSwitch.module.scss';

/**
 * A reusable toggle switch component with a customizable label.
 *
 * @component
 * @example
 *
 * const ExampleComponent = () => {
 *   const [isChecked, setIsChecked] = useState(false);
 *
 *   const handleToggleChange = (checked: boolean) => {
 *     setIsChecked(checked);
 *   };
 *
 *   return (
 *       <ToggleSwitch
 *         label="Test Mode"
 *         id="test-mode"
 *         checked={isChecked}
 *         onCheckedChange={handleToggleChange}
 *         style={{ margin: '20px' }}
 *       />
 *   );
 * };
 */
type Props = {
    style?: React.CSSProperties;
    label?: string;
    id: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
};

export const ToggleSwitch = ({ label, id, checked, onCheckedChange, style }: Props) => {
    return (
        <Flex alignItems="center" style={style}>
            <Switch.Root
                id={id}
                checked={checked}
                onCheckedChange={onCheckedChange}
                className={styles.switchWrapper}
            >
                <Switch.Thumb className={styles.switchThumb} />
            </Switch.Root>

            <label htmlFor={id} className={styles.switchLabel}>
                {label}
            </label>
        </Flex>
    );
};
